import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'module',
    templateUrl: './module.component.html',
    styleUrls: ['./module.component.scss'],
    providers: [ComponentContextService],
})
export class ModuleComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _moduleService: ModuleService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._moduleService;

        this.setting.objectName = 'phân hệ'

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên phân hệ', description: 'Tên phân hệ' }),
            new ModelSchema({ field: 'orderNo', dataType: 'int', name: 'Thứ tự', fullName: 'Thứ tự', description: 'Thứ tự' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã phân hệ', description: 'Mã phân hệ' }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'orderNo' }),
            new ColumnSchemaBase({ field: 'description' }),
        ];

        super.ngOnInit();
    }
}

